import React from 'react'
import { PopIcon } from '../setup/screen'
import BasicForm from '../../../components/formV4'
import _ from 'lodash'
import styled from 'styled-components'

const Container = styled.div`
  width: 378px;
  margin-top: 40px;
  .ant-form-item .ant-form-item-label {
    background: transparent;
    margin-top: -24px;
    label {
      background: transparent;
    }
  }
`

export default function PaymentMethodSelection(props) {
  const { paymentMethod, setPaymentMethod } = props
  // const [refForm, setRefForm] = useState(null)
  const paymentMethodFormData = [
    {
      type: 'select',
      label: (
        <>
          <span style={{ marginRight: '5px' }}>Payment Method {paymentMethod === 'card' ?
            (<span style={{ color: 'red', fontWeight: 'bold', fontSize: '10px' }}>
              ( standard 3% service fee will be included to your invoice )
            </span>) : ''}
          </span>
        </>
      ),
      options: [
        {
          value: 'bank',
          label: 'Bank Account',
        },
        {
          value: 'card',
          label: 'Credit Card'
        }
      ],
      dbField: 'paymentMethod',
      colSpan: 24,
      placeholder: 'Select',
      rules: [
        { required: true, message: 'Please select a payment method to proceed' }
      ]
    }
  ]
  return (
    <Container className="price-tip select-form">
      <BasicForm
        wrappedComponentRef={(form) => {
          form && form.validateFields()
          // setRefForm(form)
        }}
        formData={paymentMethodFormData}
        initialValues={{ paymentMethod }}
        onChange={({ paymentMethod }) => {
          setPaymentMethod && setPaymentMethod(paymentMethod)
        }}
      />
    </Container>
  )
}
